import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';

import INFO from '../../assets/info.svg';

import FormInput from '../FormInput';
import Footer from '../Footer';

import * as ROUTES from '../../constants/routes';
import { EVENT_SLUG } from '../../constants/bibConfig';
import UserManager from '../../UserManager';

import './index.css';

class SignIn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      code: '',
      error: null,
      isLoading: false,
    };

    this._onSubmit = this.onSubmit.bind(this);
    this._onChange = this.onChange.bind(this);
    this._getRef = this.getRef.bind(this);

    this.codeInputRef = React.createRef();
  }

  onError() {
    this.setState({ error: 'Code incorrect', isLoading: false });
    this.codeInputRef.current.focus();
  }

  onSubmit(event) {
    const { history, firebase } = this.props;
    const { code } = this.state;

    const db = firebase.firestore();
    const analytics = firebase.analytics();
    const vouchersRef = db
      .collection('Voucher')
      .where('code', '==', code)
      .where('eventSlug', '==', EVENT_SLUG);

    this.setState({ isLoading: true });
    vouchersRef.get().then((querySnapshot) => {
      if (!querySnapshot.empty) {
        querySnapshot.forEach((doc) => {
          const voucher = doc.data();

          UserManager.getInstance().currentUser = true;
          UserManager.getInstance().bibNumber = voucher.bibNumber;
          UserManager.getInstance().level = voucher.level;
          analytics.logEvent('authentification_success', {
            voucher_code: code,
            bib_number: voucher.bibNumber,
            level: voucher.level,
            event_slug: EVENT_SLUG,
          });

          history.push(ROUTES.LANDING);
        });
        this.setState({ error: null });
      } else {
        analytics.logEvent('authentification_failed', {
          voucher_code: code,
          event_slug: EVENT_SLUG,
        });
        this.onError();
      }
    }).catch((error) => {
      console.log(error);
      analytics.logEvent('authentification_failed', {
        voucher_code: code,
        event_slug: EVENT_SLUG,
        error_message: error,
      });
      this.onError();
    });

    event.preventDefault();
  }

  onChange(event) {
    this.setState({ [event.target.name]: event.target.value.trim() });
  }

  getRef(ref) {
    this.codeInputRef = ref;
  }

  renderButtonTitle() {
    const { isLoading } = this.state;

    if (isLoading) {
      return (
        <div className="loader m-auto" />
      );
    }

    return (<span>Valider</span>);
  }

  render() {
    const { error, isLoading } = this.state;

    return (
      <div className="sign-in">
        <Container className="text-center">
          <div className="m-3 mt-4">
            <h2>Pour imprimer votre dossard, vous devez entrer votre code</h2>

            <Form onSubmit={this._onSubmit} className="mt-3">
              <FormInput
                onChange={this._onChange}
                getRef={this._getRef}
                name="code"
                placeholder="CODE"
                label="code"
                isRequired
              />
              <Form.Text className="text-muted">
                <img className="m-1" src={INFO} alt="Info" />
                <span>Utilisez le même code lors de l'inscription à la course.</span>
              </Form.Text>
              <Button className="mt-3 mb-3 green-button" type="submit" disabled={isLoading}>
                {this.renderButtonTitle()}
              </Button>

              <div className="errorMessage">
                {error}
              </div>
            </Form>
          </div>
        </Container>

        <Footer />
      </div>
    );
  }
}

export default withRouter(SignIn);
